import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { XCircle, ArrowLeft } from 'lucide-react';

const CreditCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen hero-background flex items-center justify-center p-4">
      <Card className="bg-gray-900 border-gray-800 w-full max-w-md">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-red-400" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Payment Cancelled</h2>
          <p className="text-gray-400 mb-6">Your purchase was cancelled. No charges were made.</p>
          <div className="flex gap-3">
            <Button
              onClick={() => navigate('/credits')}
              className="flex-1 bg-purple-600 hover:bg-purple-700"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Credits
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CreditCancel;
